export default {
  common: {
    confirm: '确认',
    cancel: '取消'
  }
}
